import { request } from './request';

export const getAllResponses = (page = 1, queryString = '') =>
  request(`responses?page=${page}${queryString}&limit=50`);
export const getResponseById = (id) => request(`responses/${id}`);
export const updateResponse = (id, body) =>
  request(
    `responses/${id}`,
    {
      method: 'PATCH',
      body,
    },
    'Response updated successfully!',
  );
export const deleteResponse = (id) =>
  request(
    `responses/${id}`,
    {
      method: 'DELETE',
    },
    'Response deleted successfully!',
  );
